<template>
  <button
    type="button"
    class="booking-shared-action"
    title="Download All Documents"
    :disabled="loading"
    @click.stop="onDownload"
  >
    <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" />
    <span>{{ loading ? 'Preparing…' : 'Download All Documents' }}</span>
  </button>
</template>

<script>
import { downloadBookingDocuments } from '@/utils/booking/downloadBookingDocuments'

export default {
  name: 'BookingDocumentsButton',
  props: {
    bookingId: {
      type: String,
      default: ''
    },
    module: {
      type: String,
      required: true
    }
  },
  data () {
    return { loading: false }
  },
  methods: {
    async onDownload () {
      if (!this.bookingId || this.loading) return
      this.loading = true
      try {
        await downloadBookingDocuments({ module: this.module, bookingId: this.bookingId })
      } catch (error) {
        this.$vs.notify({
          title: 'Documents',
          text: error.message || 'Failed to download documents',
          color: 'warning'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.booking-shared-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1.2;
}
.booking-shared-action:disabled {
  opacity: 0.6;
  cursor: progress;
}
.booking-shared-action:hover:not(:disabled) {
  opacity: 0.8;
}
</style>
